// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd779e6a","239":"2c4f7788","453":"a29957f8","455":"792b15b8"}[chunkId] + ".chunk.js";
};